import React from 'react';
import { Button } from 'shards-react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from '../../../redux/store';
import { setDialogMode, openDialog, selectInformation } from '../../../redux/slices/manageTradingCompanyInformation';

const AddTradingCompanyInformation = (): React.ReactElement => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  // SIDE EFFECT
  // ================================================================================

  // 確認用
  // useEffect(() => {
  // }, []);

  // EVENT HANDLER
  // ================================================================================

  /**
   * モーダルオープン
   */
  const handleAddInfo = (): void => {
    dispatch(selectInformation());
    dispatch(setDialogMode('CREATE'));
    dispatch(openDialog());
  };

  // VIEW
  // ================================================================================

  return (
    <Button className="mr-2" theme="white" onClick={handleAddInfo}>
      <i className="material-icons">add</i>
      {t('information.alert.add')}
    </Button>
  );
};

export default AddTradingCompanyInformation;
